import { mergeStyles } from '@fluentui/merge-styles';
import type BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';
import { getLeftNavMaxWidth } from './getLeftNavWidth';
/**
 * Gets the styles to be applied to the Left Pane container
 */
export function getLeftPaneStyles(
    leftNavWidth: number,
    browserWidthBucket: BrowserWidthBucket
): string {
    return mergeStyles({
        display: 'flex',
        width: leftNavWidth,
        maxWidth: getLeftNavMaxWidth(browserWidthBucket),
    });
}
